import Interaction from "../../../models/interactions/Interaction";
import NodeToggle from "../components/NodeToggle";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import { IEnableDefaultCamera } from "../../../models/interactions/EnableDefaultCamera";

export default function EnableDefaultCameraNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as IEnableDefaultCamera;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <NodeToggle
        label="Instant"
        value={interaction.Instant}
        onChange={(Instant) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            Instant,
          } as IEnableDefaultCamera)
        }
      />
    </div>
  );
}
